import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { housesSelector, streetsSelector } from '../../store/selectors';
import { setHouses } from '../../store/actions';
import useRequestHouses from '../../../../queries/useRequestHouses';
import useFilterChange from '../../hooks/useFilterChange';
import { filterDelay } from '../../constants/common';

const SelectHouses = ({ className }) => {
  const selectedStreets = useSelector(streetsSelector);
  const selectedHouses = useSelector(housesSelector);

  const [value, setValue] = useState(selectedHouses);

  const { data: houses, isFetching: isHousesFetching } = useRequestHouses(
    selectedStreets[0],
    {
      staleTime: Infinity,
      enabled: Boolean(selectedStreets.length),
    }
  );

  const change = useFilterChange({ action: setHouses, delay: filterDelay });

  const handleChange = (values) => {
    setValue(values);
    change(values);
  };

  useEffect(() => {
    setValue(selectedHouses);
  }, [selectedHouses]);

  return (
    <Select
      onChange={handleChange}
      className={className}
      loading={isHousesFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear
      placeholder="Дом"
      value={houses?.length ? value : []}
      optionFilterProp="searchtext"
    >
      {houses?.map((house) => (
        <Select.Option key={house.id} value={house.id} searchtext={house.name}>
          {house.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectHouses;
